import { atom } from 'jotai';

export const dictionaryUpdateMessageAtom = atom('');

export const dictionaryUpdateHasErrorAtom = atom(false);
